<template>
  <el-dialog title="批量修改备注" :visible.sync="dialogVisible" width="520px"
    :close-on-click-modal="false" append-to-body>
    <div class="batch-form">
      <span class="batch-label">自定义备注：</span>
      <el-input v-model="remark" type="textarea" :rows="5" />
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'BatchRemarkSetting',
  data() {
    return {
      dialogVisible: false,
      remark: ''
    }
  },
  methods: {
    // 空备注也是有效值，用于批量清除已勾选库位的备注。
    open() {
      this.remark = ''
      this.dialogVisible = true
    },
    confirm() {
      this.$emit('confirm', this.remark)
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.batch-form {
  display: flex;
  align-items: flex-start;
  min-height: 100px;
  padding: 10px 20px;
}

.batch-label {
  width: 100px;
  line-height: 40px;
  text-align: right;
  margin-right: 12px;
  flex: none;
}

.el-textarea {
  flex: 1;
}
</style>
